import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "detail-page-skeleton" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailPageSkeleton',
  props: {
    count: { default: 2 },
    type: { default: "heading, subtitle, paragraph" }
  },
  setup(__props: any) {

const props = __props;

const normalizedCount = computed(() => Math.max(1, Number(props.count) || 1));

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(normalizedCount.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: "section-card"
      }, [
        _createVNode(_component_v_skeleton_loader, {
          type: __props.type,
          style: {"border-radius":"18px","background":"transparent"}
        }, null, 8, ["type"])
      ]))
    }), 128))
  ]))
}
}

})